import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const removeRiderFromGroup = (slug: string, riderId: number) => {
  const url = `${apiConfiguration.apiUrl}/groups/${slug}/riders/${riderId}`;
  return axios.delete(url);
};
